import { Heading } from "@hypercard/web-components";

interface Props {
  title: string;
  children?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const PageWithTitle = ({ title, children, rightContent }: Props) => {
  return (
    <div className="mt-10 flex flex-grow flex-col">
      <div className="flex justify-between">
        <Heading size="lg" weight="medium" className="mb-8">
          {title}
        </Heading>
        {rightContent}
      </div>
      {children}
    </div>
  );
};
